const searchHandler = () => {
    let openSearchBtn = document.querySelector('.search__button')
    let iconOpen = document.querySelector('.button-icon-open')
    let iconClose = document.querySelector('.button-icon-close')
    let searchForm = document.querySelector('.search-container')
    let nav = document.querySelector('.navigation')

    let overlay = document.querySelector('.overlay')

    openSearchBtn.addEventListener('click', () => {
        if (openSearchBtn.classList.contains('open')) {
            openSearchBtn.classList.remove('open')
            overlay.classList.remove('overlay--visible')

            iconOpen.style.display = 'block'
            iconClose.style.display = 'none'

            searchForm.style.display = 'none'
            searchForm.style.opacity = '0'
            searchForm.style.visibility = 'hidden'
            searchForm.style.zIndex = '-100'

            nav.style.display = 'block'
        } else {
            openSearchBtn.classList.add('open')
            overlay.classList.add('overlay--visible')

            iconOpen.style.display = 'none'
            iconClose.style.display = 'block'

            searchForm.style.display = 'block'
            searchForm.style.opacity = '1'
            searchForm.style.visibility = 'visible'
            searchForm.style.zIndex = '99999'

            nav.style.display = 'none'

            openSearchBtn.classList.add('open')
        }
    })
}

export default searchHandler
